/* globals confirm, Front */
(function($) {
	'use strict';
	$.fn.Collection__ClearAllComments = function() {
		this.each(function() {

			/*
			 * Action: Clear All Comments
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// Get options
				var collection_id = $self.data('cid');

				// Add confirm
				var confirmed = confirm( Front.translations.confirm_clear_all_comments );
				if( confirmed ) {

					$.Globals.ajax( 'collection_clear_all_comments', { cid: collection_id }, function() {

						console.log('done');

						// Track in Google
						$.Globals.track_event( 'Collection Notes Cleared' );

						// Clear all of the comments on this page (list view)
						$('.slide--list-comments > .comments').each( function() {
							$(this).html('');
						});

						// Close the overlay
						$.Globals.closeOverlay();

					});

				}

			});

		});
		return this;
	};
}(jQuery));
